import { alasanTtdMengunciHapus, SlotTtd } from "@/utils/hapusSetelahTtd";

export const STATUS_BOLEH_HAPUS_PERMINTAAN = ["draft", "dikirim", "dibatalkan"];

export const ALASAN_HAPUS_SUDAH_DITERIMA = "Sudah diterima Bank Darah, tidak dapat dihapus";

export function alasanTidakBisaHapusPermintaan(
  status: string | null | undefined,
  pembuatId: unknown,
  slots: SlotTtd[],
  userId: unknown
): string {
  if (STATUS_BOLEH_HAPUS_PERMINTAAN.indexOf(status || "draft") < 0) {
    return ALASAN_HAPUS_SUDAH_DITERIMA;
  }
  return alasanTtdMengunciHapus(pembuatId, slots, userId);
}
